import { Component, inject, input, model, OnChanges, OnInit, signal, SimpleChanges } from '@angular/core';
import { DialogService } from '@shared/component.dialog';
import { DeviceIdService } from '@shared/services.device-id';
import { WindowService } from '@shared/services.window';
import { environment } from '@environments/environment';
import { PromoDetailData } from '../../../promo-detail/promo-detail';
import { PromoDetailComponent } from '../../../promo-detail/promo-detail.component';
import { TranslatePipe } from '@ngx-translate/core';
import { PackageCardComponent } from './components/package-card/package-card.component';
import { PoinCardComponent } from './components/poin-card/poin-card.component';
import { PostCartDto, PostCartResp } from '../../../../../../../@core/usecase/cart/cart.interface';
import { Poin } from '../../../../../../../@core/domain/poin.entity';
import { PostCartUsecase } from '../../../../../../../@core/usecase/cart/post-cart.usecase';
import { OfferListData } from './offer-list';
import { ITEM } from '@utils/constants';
import { PromoType } from '@data/domain/promo.entity';
import { ErrorMessage } from '@shared/services/error-message/error-message.interface';
import { ErrorModalComponent } from '@shared/components/error-modal/error-modal.component';
import { ErrorModal } from '@shared/components/error-modal/error-modal.interface';
import { DataPackageList } from '@usecase/package/get-package/get-package.interface';
import { ActivatedRoute, Router } from '@angular/router';
import { OrderData } from '@data/domain/checkout.entity';
import { CreateOrderAffiliateDto, CreateOrderAffiliateResp } from '@usecase/checkout/create-order-btl/create-order-affiliate.interface';
import { CreateOrderAffiliateUsecase } from '@usecase/checkout/create-order-btl/create-order-affiliate.usecase';
import { CreateOrderPackageDto } from '@usecase/checkout/create-order-package/create-order-package.interface';
import { CreateOrderPackageUsecase } from '@usecase/checkout/create-order-package/create-order-package.usecase';
import { VoucherCardComponent } from './components/voucher-card/voucher-card.component';
import { NgClass } from '@angular/common';
import { GtmTrackingService } from '../../../../../../shared/services/gtm-tracking.service';

@Component({
  selector: 'app-offer-list',
  standalone: true,
  imports: [TranslatePipe, PackageCardComponent, PoinCardComponent, VoucherCardComponent, NgClass],
  templateUrl: './offer-list.component.html',
  styleUrl: './offer-list.component.scss'
})

export class OfferListComponent implements OnChanges, OnInit {
  data = model<OfferListData>({
    packages:[],
    poins: []
  });
  campaignId = input<string>();
  promoType = model<PromoType>('promo');
  msisdn = input<string>('');
  isAffiliatePackage = input<boolean>(false);

  packageSliced = signal<DataPackageList[]>([]);
  poinSliced = signal<Poin[]>([]);

  isShowPromoDetail: boolean = false;

  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly dialogService = inject(DialogService);
  private readonly createOderUsecase = inject(CreateOrderPackageUsecase);
  // deviceIdService ?
  private readonly deviceIdService = inject(DeviceIdService);
  private readonly windowService = inject(WindowService);
  private readonly postCartUsecase = inject(PostCartUsecase);
  private readonly createOrderAffiliateUsecase = inject(CreateOrderAffiliateUsecase);
  private readonly gtmTrackingService = inject(GtmTrackingService);

  get hasMorePackages() {
    return this.packageSliced().length < this.data()?.packages.length || this.poinSliced().length < this.data().poins.length;
  }

  ngOnChanges(changes: SimpleChanges): void {
    const data = changes['data']?.currentValue as OfferListData;
    if (data?.packages.length === ITEM.EMPTY_LENGTH && data?.poins.length === ITEM.EMPTY_LENGTH) {
      this.packageSliced.set([]);
      this.poinSliced.set([]);
    }
  }

  ngOnInit() {
    this.packageSliced.set(this.data()?.packages.slice(ITEM.START_INDEX, ITEM.INITIAL_ITEMS));
    this.poinSliced.set(this.data()?.poins.slice(ITEM.START_INDEX, ITEM.INITIAL_ITEMS));
  }

  onClickPackage(event: DataPackageList) {
    // Track package selection
    this.gtmTrackingService.trackPackageSelection(event, this.promoType());

    this.isShowPromoDetail = !this.isShowPromoDetail;
    const dialogData:PromoDetailData = {
      ...event,
      // btnLabel: btn,
      msisdn: Number(this.msisdn()),
      isAffiliatePackage: this.isAffiliatePackage()
    };
    const dialogRef = this.dialogService.open(PromoDetailComponent, {
      data: dialogData
    });

    dialogRef.instance().buy.subscribe((res:PromoDetailData) => {
    // Track purchase intent
    this.gtmTrackingService.trackPurchaseIntent(res, this.promoType());

    dialogRef.close() ;
    if(this.promoType() === 'affiliate') return this.createOrderAffiliate(res);
    if(this.promoType() === 'roamingUmrahHaji') return this.handleRoamingUmrahHaji(res);
    this.createOrderPromo(res);
  });
  };

  onClickShowMore() {
    this.packageSliced.set(this.data().packages);
    this.poinSliced.set(this.data().poins);
  }

  onClickShowLess() {
    this.packageSliced.set(this.data().packages.slice(ITEM.START_INDEX, ITEM.INITIAL_ITEMS));
    this.poinSliced.set(this.data().poins.slice(ITEM.START_INDEX, ITEM.INITIAL_ITEMS));
  }

  createOrderPromo(data: PromoDetailData) {
    const payload: CreateOrderPackageDto = {
      deviceId: this.deviceIdService.getDeviceId(),
      msisdn: this.formatMsisdn(this.msisdn()),
      telcoPackage: [{
        packageId: data.id
      }],
      tag: 'promo',
      campaignId: this.route.snapshot.params['content']
    };

    this.createOderUsecase.execute(payload).subscribe({
      next: (res: OrderData) => {
        const type = this.route.snapshot.params['content'] === 'telkomselberbagi' ? '&type=simpul' : '';

        this.windowService.assign(`${environment.drupalApi}shops/payment/${res.code}?msisdn=${this.msisdn()}&packageId=${data.id}${type}`);
      },
      error: (error: ErrorMessage) => {
        this.openPopupError(error);
      }
    });
  }

  createOrderAffiliate(data: PromoDetailData) {
    const payload: CreateOrderAffiliateDto = {
      deviceId: this.deviceIdService.getDeviceId(),
      msisdn: this.formatMsisdn(this.msisdn()),
      tag: 'promo',
      packageId: data.businesspid ?? '',
      promoName: this.route.snapshot.params['content'],
      affiliatorId: this.route.snapshot.queryParams['utm_id']
    };

    this.createOrderAffiliateUsecase.execute(payload).subscribe({
      next: (res: CreateOrderAffiliateResp) => {
        this.windowService.assign(`${environment.drupalApi}shops/payment/${res.data.code}?msisdn=${this.msisdn()}&packageId=${data.id}`);
      },
      error: (error: ErrorMessage) => {
        this.openPopupError(error);
      }
    });

  }

  onClickPoin(data: Poin) {
    const dialogData: PromoDetailData = {
      ...data,
      isAffiliatePackage: this.isAffiliatePackage()
    };
    const dialogRef = this.dialogService.open(PromoDetailComponent, {
      data: dialogData
    });
    dialogRef.instance().buy.subscribe({
      next: (res: PromoDetailData) => {
        this.handlePostCart(res);
      }
    });
  }

  handlePostCart(data: PromoDetailData) {
    const payload: PostCartDto = {
      source: 'cart',
      data: [
        {
          qty: 1,
          keyword: data.keyword,
          point: data.price,
          name: data.name,
          Teaser: data.longdesc,
          expired: ''
        }
      ]
    };

    this.postCartUsecase.execute(payload).pipe().subscribe({
      next: (res: PostCartResp) => {
        this.windowService.replace(environment.drupalApi + 'shops/redeem/' + res.cart_id + `?msisdn=${this.msisdn()}`);
      }
    });
  }
  formatMsisdn(phoneNumber: string): string {
    const FIRST_DIGIT_INDEX = 1;
    if (phoneNumber.startsWith('0')) {
      // pake string literal biar lebih mudah dibaca
      return String('62' + phoneNumber.slice(FIRST_DIGIT_INDEX));
    }
    // return nya pake ternary aja
    return String(phoneNumber);
  }

  openPopupError(error: ErrorMessage) {
    const {title, description, image, firstButton, secondButton} = error;
    this.dialogService.open(ErrorModalComponent, {
      data: {
        title: title,
        description: description,
        image: image,
        firstButton: firstButton,
        secondButton: secondButton
      } as ErrorModal
    });
  }

  handleRoamingUmrahHaji(event: PromoDetailData) {
    const ML_ID = localStorage.getItem('mlId');

    const QUERY_PARAMS = {
      campaignid:this.campaignId(),
      msisdn: this.msisdn(),
      packageId: event.businesspid
    };
    this.router.navigate([`roaming/set-schedule/btl/${ML_ID}`], {queryParams: QUERY_PARAMS});
  }
}
